import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { ContentWrapper } from 'components/shared/CommonWrappers';
import { Banner } from 'components/Banner/Banner';
// import { EventList } from 'components/Event/EventList';
import { MemberList } from 'components/CTA/CTAList';
import { Announcement } from '../../components/Dashboard/Announcement';
import {
  AnnouncementPageType,
  useContactService,
  useDashboardService,
  usePersistentService,
} from 'services';
import { MembershipRenewalAlert } from 'components/membership/MembershipRenewalAlert';
import { isNewMembership } from 'helpers';

export const DashboardContent = () => {
  const { getData } = useDashboardService();
  const myMembershipsData = useContactService((s) => s.myMemberships.data);
  const membership = myMembershipsData?.[0];
  const newMemberRedirected = usePersistentService(
    (s) => s.newMemberRedirected,
  );
  const setNewMemberRedirected = usePersistentService(
    (s) => s.setNewMemberRedirected,
  );

  // Send new members straight to their renewal page once per login;
  // the flag is cleared on logout via the persistent store reset.
  const shouldRedirectNewMember =
    !newMemberRedirected && !!membership?.id && isNewMembership(membership);

  useEffect(() => {
    if (shouldRedirectNewMember) setNewMemberRedirected(true);
  }, [shouldRedirectNewMember, setNewMemberRedirected]);

  useEffect(() => {
    if (membership) getData(membership);
  }, [membership, getData]);

  if (shouldRedirectNewMember) {
    return <Navigate to={`/membership/${membership?.id}/renewal`} replace />;
  }

  return (
    <ContentWrapper>
      <Banner />
      <MembershipRenewalAlert />
      <Announcement type={AnnouncementPageType.DASHBOARD} />
      <MemberList />
      {/* <EventList /> */}
    </ContentWrapper>
  );
};
